// extracted by mini-css-extract-plugin
export default {"applicant-button":"style_applicant-button__i27K7"};